import i18n from "@/Language/i18n";
import { lazyWithErrorHandle } from "@/utils/utils";
import title from "./title";

export default {
  path: "/developMeeting",
  meta: {
    title: title(i18n.t("Overseas_sales_overseasMTG")),
    roles: ["developMeeting"],
  },
  children: [
    {
      path: "developMeeting-newStoreProgress",
      meta: {
        title: i18n.t("OverseasDevelopMeeting_tableTitle"),
        roles: ["developMeeting-newStoreProgress"],
      },
      component: lazyWithErrorHandle(() => import("@/pages/overseasDevelopMeeting")),
    },
    {
      path: "developMeeting-meetingList",
      meta: {
        title: i18n.t("OverseasMeetingList_pageTitle"),
        roles: ["developMeeting-meetingList"],
      },
      component: lazyWithErrorHandle(() => import("@/pages/MeetingList")),
    },
    {
      path: "developMeeting-closingSchedule",
      meta: {
        title: i18n.t("ClosingSchedule_pageTitle"),
        roles: ["developMeeting-closingSchedule"],
      },
      component: lazyWithErrorHandle(() => import("@/pages/ClosingSchedule")),
    },
  ],
};
